import { AxiosResponse } from 'axios';
import { StorageItem } from '../../../../../apis/client-axios';
import { getEffectiveDims } from '../../../../../util/ship-dims';
import './SizeInfo.scss';

type TProps = {
  itemDetail?: AxiosResponse<StorageItem, any>;
  dataShipping?: any;
  hideMetrics?: boolean;
  title: string;
};

const SizeInfo = ({ itemDetail, dataShipping, hideMetrics = false, title }: TProps) => {
  const formatMetric = (value?: number | string) => {
    return Number(Number(value || 0).toFixed(2)).toString();
  };
  const displayMetric = (value?: number | string) => (hideMetrics ? '' : formatMetric(value));

  // Item chưa lưu kho không có 保管サイズ -> hiển thị 到着時サイズ (đúng số mà 送料 tạm tính dựa vào).
  // Trước đây storageLength luôn có nên vế `dataShipping.reportLength` không bao giờ chạy ở trang
  // tạo đơn lẻ (không truyền dataShipping) — item chưa lưu kho làm nó chạy thật và crash vì
  // dataShipping undefined. Item có 保管サイズ: hiển thị y như cũ.
  const eff = getEffectiveDims(itemDetail?.data);

  return (
    <div className="box box-size__info">
      <div className="title">
        <h3>{title}</h3>
      </div>
      <div className="list-info size-info">
        <div className="size-info__item">
          <span className="size-info__item-label">梱包サイズ（cm）</span>
          <div className={`size-info__item-value ${hideMetrics ? 'is-disabled' : ''}`.trim()}>
            <div className="detail">
              <span>縦</span>
              <div className="number">
                <span>
                  {displayMetric(itemDetail?.data?.storageLength || eff?.length || dataShipping?.reportLength)}
                </span>
              </div>
            </div>
            <div className="detail">
              <span>横</span>
              <div className="number">
                <span>{displayMetric(itemDetail?.data?.storageWidth || eff?.width || dataShipping?.reportWidth)}</span>
              </div>
            </div>
            <div className="detail">
              <span>高さ</span>
              <div className="number">
                <span>
                  {displayMetric(itemDetail?.data?.storageHeight || eff?.height || dataShipping?.reportHeight)}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="size-info__item">
          <span className="size-info__item-label">重量（kg）</span>
          <div className={`size-info__item-value ${hideMetrics ? 'is-disabled' : ''}`.trim()}>
            <div className="detail detail-weight">
              <div className="number">
                <span>
                  {displayMetric(itemDetail?.data?.storageWeight || eff?.weight || dataShipping?.reportWeight)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SizeInfo;
